import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import * as types from "@/store/constants/types";

var LoadingAnimaton =
/*#__PURE__*/
function (_Vue) {
  _inherits(LoadingAnimaton, _Vue);

  function LoadingAnimaton() {
    _classCallCheck(this, LoadingAnimaton);

    return _possibleConstructorReturn(this, _getPrototypeOf(LoadingAnimaton).apply(this, arguments));
  }

  return LoadingAnimaton;
}(Vue);

tslib_1.__decorate([Prop()], LoadingAnimaton.prototype, "backGround", void 0);

tslib_1.__decorate([Prop()], LoadingAnimaton.prototype, "radColor", void 0);

tslib_1.__decorate([Prop({
  default: 'rgba(255,255,255,0)'
})], LoadingAnimaton.prototype, "loadBg", void 0);

tslib_1.__decorate([Getter(types.GETTER_LOADING_STATUS)], LoadingAnimaton.prototype, "showLoading", void 0);

LoadingAnimaton = tslib_1.__decorate([Component({
  components: {}
})], LoadingAnimaton);
export default LoadingAnimaton;